import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Mail, ArrowLeft, Check } from 'lucide-react';

const API_URL = process.env.REACT_APP_API_URL || (window.location.origin + '/api');

export default function ForgotPassword() {
  const [email, setEmail]     = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone]       = useState(false);
  const [emailSent, setEmailSent] = useState(false);
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const r = await fetch(`${API_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.error);
      setEmailSent(d.email_sent);
      setDone(true);
    } catch (err) {
      setError(err.message || 'Error procesando solicitud.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'linear-gradient(135deg, var(--bg-subtle) 0%, #e0e7ff 100%)', padding: 24,
    }}>
      <div style={{ width: '100%', maxWidth: 420 }}>
        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ width: 52, height: 52, background: 'var(--ink)', borderRadius: 14, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 12 }}>
            <Mail size={26} color="#fff" />
          </div>
          <h1 style={{ fontSize: 22, fontWeight: 800, color: 'var(--ink)', margin: '0 0 4px' }}>Recuperar contraseña</h1>
          <p style={{ fontSize: 13, color: 'var(--ink-3)', margin: 0 }}>NODWARD</p>
        </div>

        <div className="card" style={{ padding: 32 }}>
          {!done ? (
            <>
              <p style={{ fontSize: 14, color: 'var(--ink-2)', marginBottom: 24, lineHeight: 1.6, textAlign: 'center' }}>
                Ingresá tu email y te enviaremos un link para restablecer tu contraseña.
              </p>

              {error && (
                <div style={{ background: 'var(--red-dim)', border: '1px solid var(--red-dim)', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: 'var(--red)', marginBottom: 16 }}>
                  {error}
                </div>
              )}

              <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink-2)', display: 'block', marginBottom: 6 }}>
                    Email corporativo
                  </label>
                  <input
                    type="email" required autoFocus
                    value={email} onChange={e => setEmail(e.target.value)}
                    placeholder="usuario@empresa.com"
                    style={{ width: '100%', padding: '11px 14px', border: '1.5px solid var(--border)', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }}
                  />
                </div>
                <button
                  type="submit" disabled={loading}
                  style={{ padding: '12px 0', background: 'var(--ink)', color: 'var(--surface)', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 700, cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.7 : 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}>
                  <Mail size={16} />
                  {loading ? 'Enviando...' : 'Enviar link de recuperación'}
                </button>
              </form>
            </>
          ) : (
            <div style={{ textAlign: 'center' }}>
              <div style={{ width: 56, height: 56, borderRadius: '50%', background: 'var(--green-dim)', border: '2px solid var(--green-dim)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
                <Check size={28} color="var(--green)" />
              </div>
              <h2 style={{ fontSize: 18, fontWeight: 700, color: 'var(--ink)', margin: '0 0 8px' }}>Solicitud recibida</h2>
              {emailSent ? (
                <p style={{ fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.6, margin: '0 0 8px' }}>
                  Enviamos un email a <strong>{email}</strong> con el link para restablecer tu contraseña.
                  Revisá tu bandeja de entrada (y spam).
                </p>
              ) : (
                <p style={{ fontSize: 14, color: 'var(--ink-2)', lineHeight: 1.6, margin: '0 0 8px' }}>
                  Tu solicitud fue registrada. <strong>Contactá a tu administrador</strong> para que te comparta el link de recuperación.
                </p>
              )}
              <p style={{ fontSize: 12, color: 'var(--ink-3)', margin: '0 0 24px' }}>El link expira en 1 hora.</p>
            </div>
          )}

          <div style={{ textAlign: 'center', marginTop: 20 }}>
            <Link to="/login" style={{ color: 'var(--accent)', fontSize: 13, textDecoration: 'none', display: 'inline-flex', alignItems: 'center', gap: 4, fontWeight: 500 }}>
              <ArrowLeft size={14} /> Volver al inicio de sesión
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
